export default {
  primary: {
    backgroundColor: 'dark',
    color: 'light',
    border: 'solid 2px',
    borderColor: 'primary',
    padding: '1rem 2rem',
    fontSize: ['1rem', '', '1.1rem'],
    fontWeight: 'bold',
    TextTransform: 'uppercase',
    borderColor: 'dark',
    ':hover': {
      backgroundColor: 'transparent',
      color: 'text'
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    color: 'primary',
    border: 'solid 2px',
    borderColor: 'primary',
    ':hover': {
      backgroundColor: 'primary',
      color: 'white'
    }
  }
}
